import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AssetManagement, AssetVerify, AssetView, EmpDetailsReportAndDashboard } from "@aptsi-types";
import { environment } from "@env";
import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { ErrorHandlingService } from "../../shared/errorHandling/errorHandling.service";
import { API_ENDPOINTS } from "../../digital-identity-api-endpoints";



interface GetAssetDigitalIdentityResponse {
    digitalidentitydashboard: EmpDetailsReportAndDashboard;
}

interface GetAssetDigitalIdentitysResponse {
    digitalidentitydashboards: EmpDetailsReportAndDashboard[];
}

@Injectable({
  providedIn: "root",
})
export class DigitalIdentityDashboardService {
  private readonly assetmanagementreportsUrl = environment.apiUrl;

  constructor(
    private http: HttpClient,
    private errorHandlingService: ErrorHandlingService
  ) {}
  
  getDiDashboardCardsData(): Observable<EmpDetailsReportAndDashboard> {
    return this.http
      .post<GetAssetDigitalIdentityResponse>(
        `${this.assetmanagementreportsUrl}${API_ENDPOINTS.DASHBOARD.FETCHCARDDATA}`,
        { }
      )
      .pipe(
        map((response) => response.digitalidentitydashboard),
        catchError((error) => this.errorHandlingService.handleError(error))
      );
  }

  // getDiDashboardChartData(): Observable<EmpDetailsReportAndDashboard[]> {
  //   return this.http
  //     .post<GetAssetDigitalIdentitysResponse>(
  //       `${this.assetmanagementreportsUrl}${API_ENDPOINTS.DASHBOARD.FETCHCHARTDATA}`,
  //       { }
  //     )
  //     .pipe(
  //       map((response) => response.digitalidentitydashboards),
  //       catchError((error) => this.errorHandlingService.handleError(error))
  //     );
  // }

}
